import React from 'react'
import { Button, Form, Modal, Radio, Icon} from "semantic-ui-react";
import { socket } from "../../../lib/socketio";
import { setIsMute } from '../../../actions/SoundActions';

import { useSelector, useDispatch, connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setCurrentPLC } from '../../../actions/headerActions';

const SoundSettings = ({addHeader}) => {

    const [open, setOpen] = React.useState(false);
    const [selectUrl, setSelectUrl] = React.useState();

    const location = useLocation();
    const dispatch = useDispatch();

    const currentPLC = useSelector(state => state.header.currentPLC);
    const isMute = useSelector((state) => state.sound.isMute);

    React.useEffect(()=> {
        dispatch(setCurrentPLC(location.pathname.slice(-4)));
    },[]);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleSaveClick = () => {
        setOpen(false);
    }

    const handleRadioChange = (e, data) => {
        const toggle = data.checked;
        dispatch(setIsMute(toggle));
    }

    return (
        <div style={styles.div}>
            <h1 style={styles.header}>Alarm Sound Settings</h1>
            {addHeader ?
                <h4 style={styles.header}>{addHeader}</h4>
                : ''
            }
            <Modal trigger = {<Button color = 'vk'>Sound Settings</Button>}
                   style = {{width: '600px'}}
                   open = {open}
                   size={'large'}
                   onClose={handleClose}
                   onOpen={handleOpen}>
                <Modal.Header>Alarm Sound Settings</Modal.Header>
                <Modal.Content style={styles.modalContent}>
                    <h3>
                        Sound Mute
                        <Icon name={isMute ? 'alarm mute' : 'alarm'} style={styles.iconStyle} />
                    </h3>
                    <Radio
                        style={{color : 'black'}}
                        toggle
                        checked={isMute}
                        label={isMute? 'Mute' : 'Unmute'}
                        onChange={handleRadioChange}
                    />


                </Modal.Content>
                <Modal.Actions style = {{marginLeft: '10px'}}>
                    <Button color={'red'}
                            size='small'
                            id = '1'
                            content='Exit'
                            onClick={handleClose}
                    />
                    <Button color={'blue'}
                            size='small'
                            id = '2'
                            content='Save'
                            onClick={handleSaveClick}
                    />
                </Modal.Actions>
            </Modal>
        </div>
    );
};

const styles = {
    label: {
        float: 'right',
        textAlign: 'center'
    },
    toggle: {
        marginLeft: '8px'
    },
    div: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    header: {
        marginBottom: '20px'
    },
    modalContent: {
        color : 'black'
    },
    toggleStyle: {
        display: 'flex',
        alignItems: 'center'
    },
    iconStyle: {
        color : 'grey',
        marginLeft : '5px'
    }
};

const contract_types = [
    {key: 1, text: 'Plant A (192.168.0.192) / Single Unit (If accessed from tech laptop)', value: 'http://192.168.0.192:4001'},
    {key: 2, text: 'Plant B (192.168.0.193)', value: 'http://192.168.0.193:4001'},
    {key: 3, text: 'Default (Defaults to the unit connected to this RMS PC)', value: 'http://localhost:4001'}
];

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

const mapStateToProps = (state) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SoundSettings);